var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"boxes"},[_c('div',{staticClass:"box"},[_c('div'),_c('div'),_c('div'),_c('div')]),_c('div',{staticClass:"box"},[_c('div'),_c('div'),_c('div'),_c('div')]),_c('div',{staticClass:"box"},[_c('div'),_c('div'),_c('div'),_c('div')]),_c('div',{staticClass:"box"},[_c('div'),_c('div'),_c('div'),_c('div')])])])
}]

export { render, staticRenderFns }